import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { AgpmRepository } from '@/store/agpm-state/agpm-state.repository';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';

interface getAGPMUploadDialogProps {
  store: AgpmRepository;
  validate: () => void;
}

export const getAGPMUploadDialog = ({ store, validate }: getAGPMUploadDialogProps): DialogObject => {
  const fileField: DynamicField<FileFieldProps> = {
    label: 'Modèle AGPM',
    variant: FieldVariant.FILE,
    isRequired: true,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: false,
      value: store.getNestedObservable<File[]>('upload', 'modelAgpmFile'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('upload', 'modelAgpmFile', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'upload',
          'modelAgpmFile',
          store.getNested<File[]>('upload', 'modelAgpmFile').filter(file => file.name !== event.file.name)
        );
      },
      message: 'common.files.warn',
    },
  };

  return {
    title: 'Téléversement',
    actions: [
      {
        label: 'Valider',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [fileField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
